import classNames from "classnames";
import React from "react";
import SVG from "react-inlinesvg";
import { connect } from "react-redux";
import {
    nearbyStoreSelector,
    preferredLocationSelector,
} from "tsi-common-react/src/apps/common/selectors";
import { TStateMapper } from "tsi-common-react/src/apps/reducers.interfaces";
import { Link } from "tsi-common-react/src/common/Link";
import { ILocation } from "tsi-common-react/src/models/location.interfaces";
import {
    BreakPoint,
    IViewport,
} from "tsi-common-react/src/models/screen.interfaces";
import { urls } from "tsi-common-react/src/utils/urls";
import { c } from "ttag";

import iconStoreLocatorFooter from "../../svg/store_locator_footer.svg";

interface IOwnProps {
    isSiteSearchOpen: boolean;
}

interface IReduxProps {
    viewport: IViewport;
    numStores: number;
    location: ILocation | null;
}

interface IProps extends IOwnProps, IReduxProps {}

interface IState {}

// TODO(ssr, LOW 3 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 3/10 due to simple render logic with 2 methods, Redux connection, and no lifecycle methods or complex state.
class NearbyStoresSearchContainer extends React.Component<IProps, IState> {
    private buildContent() {
        const shouldDisplayStores =
            this.props.numStores > 0 &&
            this.props.viewport.width > BreakPoint.MEDIUM;
        if (!shouldDisplayStores) {
            return <span>{c("NearbyStoresSearch").t`Find a Retailer`}</span>;
        }
        const locationLabel = this.props.location
            ? this.props.location.formatted_address
            : "";
        const userLocation = (
            <span className="search-nav__retailers--location" key="user-loc">
                {/* translator: fallback location: N (store|stores) near you. */}
                {locationLabel || c("NearbyStoresSearch").t`you`}
            </span>
        );
        return (
            <span className="search-nav__retailers--content">
                {this.props.numStores === 1
                    ? c("NearbyStoresSearch")
                          .jt`${this.props.numStores} store near ${userLocation}`
                    : c("NearbyStoresSearch")
                          .jt`${this.props.numStores} stores near ${userLocation}`}
            </span>
        );
    }

    render() {
        const wrapperClasses = classNames({
            "search-nav__retailers": true,
            "search-nav__retailers--hide": this.props.isSiteSearchOpen,
            "al-search-nav__link--find-a-retailer": true,
        });
        return (
            <Link
                href={urls.pageURL("find-a-retailer")}
                title={c("NearbyStoresSearch").t`Find A Retailer Near You`}
                className={wrapperClasses}
            >
                <SVG
                    className="search-nav__retailers-icon search-nav__retailers-icon--desktop"
                    src={iconStoreLocatorFooter}
                    title={c("NearbyStoresSearch").t`Locate a Store Icon`}
                />
                {this.buildContent()}
            </Link>
        );
    }
}

const mapStateToProps: TStateMapper<"retail", IReduxProps, IOwnProps> = (
    state,
    ownProps,
) => {
    return {
        viewport: state.common.viewport,
        numStores: nearbyStoreSelector(state).length,
        location: preferredLocationSelector(state),
        ...ownProps,
    };
};

export const NearbyStoresSearch = connect(mapStateToProps)(
    NearbyStoresSearchContainer,
);
